import React from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightDictionary/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const Header = () => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <div className={cn('header__content')}>
          <h1 className={cn('header__heading')}>
            Freight Dictionary
          </h1>
          <p className={cn('header__description')}>
            Navigate Freight Terms Seamlessly with Our Expert Dictionary
          </p>

          <ul className={cn('header__benefits')}>
            <li className={cn('header__benefits-item')}>Access a comprehensive glossary of freight forwarding terms</li>
            <li className={cn('header__benefits-item')}>Simplify complex freight concepts with clear definitions</li>
            <li className={cn('header__benefits-item')}>Navigate complex logistics terminology with ease</li>
            <li className={cn('header__benefits-item')}>Enhance your knowledge for smarter logistics decisions</li>
          </ul>

          <div className={cn('header__buttons')}>
            {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <Link className={cn('header__button-register')} href="/membership">
              Register
            </Link> */}
            <Link className={cn('header__button-more')} href="/company/contact-us">
              Show more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
